import {Col, Row, Typography, Space} from "@bezlimit/bezlimit-ui";
import _ from "lodash";
import {useTranslation} from "react-i18next";
import bee from "../../../../../../../../images/social_bee.svg";
import vk from "../../../../../../../../images/social_vk.svg";
import ok from "../../../../../../../../images/social_ok.svg";
import wa from "../../../../../../../../images/social_wa_c.svg";
import tg from "../../../../../../../../images/social_tg_c.svg";
import vb from "../../../../../../../../images/social_vb_c.svg";
import sk from "../../../../../../../../images/social_sk_c.svg";
import yt from "../../../../../../../../images/social_yt_c.svg";
import ya from "../../../../../../../../images/social_ya.svg";
import tt from "../../../../../../../../images/social_tt.svg";
import nav from "../../../../../../../../images/social_nav_c.svg";
import gmap from "../../../../../../../../images/social_gmap_c.svg";
import yamap from "../../../../../../../../images/social_yamap_c.svg";
import gmail from "../../../../../../../../images/social_gmail_c.svg";
import mail from "../../../../../../../../images/social_mail.svg";
import sp from "../../../../../../../../images/social_sp.jpg";
import go from "../../../../../../../../images/social_go.jpg";
import kin from "../../../../../../../../images/social_kin.jpg";
import gis from "../../../../../../../../images/social_gis_c.svg";
import bzv from "../../../../../../../../images/social_bz_v.svg";
import vk_kino from "../../../../../../../../images/vk_kino.jpg";
import vk_muz from "../../../../../../../../images/vk_muz.jpg";
import ru_tybe from "../../../../../../../../images/ru_tybe.png";
import vk_muz2 from "../../../../../../../../images/vk_muz2.jpg";
import ya_muz from "../../../../../../../../images/ya_muz.jpg";
import message1 from "../../../../../../../../images/message1.jpg";
import message2 from "../../../../../../../../images/message2.png";
import message3 from "../../../../../../../../images/message3.jpg";

export default function Mobile({price, group_name, sms, minutes, internet, id}: IProps) {
    const {t} = useTranslation();
    return (
        <Row className="row-list-service">
            <Col span={24} className="col-list-service-desctop">
                <Space direction="vertical" size={8}>
                    {!_.isEqual(group_name, "Безлимит PRO") &&
                        !_.isEqual(group_name, "Безлимит ПРО") && (
                            <Row className="social-icons-row">
                                <Col span={7}>
                                    {" "}
                                    <img src={wa} width={14} alt="logo" className="social-icon" />
                                    <img src={tg} width={14} alt="logo" className="social-icon" />
                                    <img src={vb} width={14} alt="logo" className="social-icon" />
                                    <img src={sk} width={14} alt="logo" className="social-icon" />
                                </Col>
                                <Col span={17}>
                                    {" "}
                                    <Typography as="div" className="social-icons-text">
                                        {t("Безлимит на Мессенджеры")}
                                    </Typography>
                                </Col>
                            </Row>
                        )}

                    {_.isEqual(group_name, "Безлимит PRO") ||
                    _.isEqual(group_name, "Безлимит ПРО") ||
                    _.isEqual(group_name, "Интернет PRO") ||
                    _.isEqual(group_name, "Интернет ПРО") ? (
                        <>
                            <Row className="social-icons-row">
                                <Col span={8}>
                                    <img src={kin} width={14} alt="logo" className="social-icon" />
                                    <img src={go} width={14} alt="logo" className="social-icon" />
                                    <img src={ya} width={14} alt="logo" className="social-icon" />
                                    <img src={sp} width={14} alt="logo" className="social-icon" />
                                    <img
                                        src={yamap}
                                        width={14}
                                        alt="logo"
                                        className="social-icon"
                                    />
                                </Col>
                                <Col span={16}>
                                    <Typography as="div" className="social-icons-text">
                                        {t("Безлимит на сервисы Яндекса")}
                                    </Typography>
                                </Col>
                            </Row>
                            <Row className="social-icons-row">
                                <Col span={8}>
                                    <img src={vk} width={14} alt="logo" className="social-icon" />
                                    <img src={ok} width={14} alt="logo" className="social-icon" />
                                </Col>
                                <Col span={16}>
                                    <Typography as="div" className="social-icons-text">
                                        {t("Безлимит на Соцсети")}
                                    </Typography>
                                </Col>
                            </Row>
                            <Row className="social-icons-row">
                                <Col span={8}>
                                    <img src={tt} width={14} alt="logo" className="social-icon" />
                                    <img
                                        src={vk_kino}
                                        width={14}
                                        alt="logo"
                                        className="social-icon"
                                    />
                                    <img
                                        src={vk_muz}
                                        width={14}
                                        alt="logo"
                                        className="social-icon"
                                    />
                                    <img
                                        src={ru_tybe}
                                        width={14}
                                        alt="logo"
                                        className="social-icon"
                                    />
                                </Col>
                                <Col span={16}>
                                    <Typography as="div" className="social-icons-text">
                                        {t("Безлимит на Видео")}
                                    </Typography>
                                </Col>
                            </Row>
                            <Row className="social-icons-row">
                                <Col span={8}>
                                    <img
                                        src={vk_muz2}
                                        width={14}
                                        alt="logo"
                                        className="social-icon"
                                    />
                                    <img
                                        src={ya_muz}
                                        width={14}
                                        alt="logo"
                                        className="social-icon"
                                    />
                                </Col>
                                <Col span={16}>
                                    <Typography as="div" className="social-icons-text">
                                        {t("Безлимит на Музыку")}
                                    </Typography>
                                </Col>
                            </Row>
                            <Row className="social-icons-row">
                                <Col span={8}>
                                    <img src={wa} width={14} alt="logo" className="social-icon" />
                                    <img src={tg} width={14} alt="logo" className="social-icon" />
                                    <img
                                        src={message1}
                                        width={14}
                                        alt="logo"
                                        className="social-icon"
                                    />
                                    <img
                                        src={message2}
                                        width={14}
                                        alt="logo"
                                        className="social-icon"
                                    />
                                    <img
                                        src={message3}
                                        width={14}
                                        alt="logo"
                                        className="social-icon"
                                    />
                                </Col>
                                <Col span={16}>
                                    <Typography as="div" className="social-icons-text">
                                        {t("Безлимит на Мессенджеры")}
                                    </Typography>
                                </Col>
                            </Row>
                            {!_.isEqual(id, 15807) && (
                                <Row className="social-icons-row">
                                    <Col span={8}>
                                        <img
                                            src={bzv}
                                            width={16}
                                            alt="logo"
                                            className="social-icon "
                                        />
                                    </Col>
                                    <Col span={16}>
                                        <Typography as="div" className="social-icons-text">
                                            {t("Безлимит на Безлимит")}
                                        </Typography>
                                    </Col>
                                </Row>
                            )}
                            {!_.isEqual(id, 15807) && (
                                <Row className="social-icons-row">
                                    <Col span={8}>
                                        <img
                                            src={bee}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                    </Col>
                                    <Col span={16}>
                                        {" "}
                                        <Typography as="div" className="social-icons-text">
                                            {t("Безлимит на Билайн")}
                                        </Typography>
                                    </Col>
                                </Row>
                            )}
                        </>
                    ) : (
                        <>
                            {_.gt(price, 1100) ? (
                                <Row className="social-icons-row">
                                    <Col span={7}>
                                        <img
                                            src={vk}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                        <img
                                            src={ok}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                    </Col>
                                    <Col span={17}>
                                        <Typography as="div" className="social-icons-text">
                                            {t("Безлимит на Соц сети")}
                                        </Typography>
                                    </Col>
                                </Row>
                            ) : null}

                            {_.gt(price, 1100) ? null : (
                                <Row className="social-icons-row">
                                    <Col span={7}>
                                        <img
                                            src={kin}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                        <img
                                            src={go}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                        <img
                                            src={ya}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                        <img
                                            src={sp}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                    </Col>
                                    <Col span={17}>
                                        {" "}
                                        <Typography as="div" className="social-icons-text">
                                            {t("Безлимит на сервисы Яндекса")}
                                        </Typography>
                                    </Col>
                                </Row>
                            )}
                            {_.lte(price, 1100) ? (
                                <Row className="social-icons-row">
                                    <Col span={7}>
                                        <img
                                            src={vk}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                        <img
                                            src={ok}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                    </Col>
                                    <Col span={17}>
                                        <Typography as="div" className="social-icons-text">
                                            {t("Безлимит на Соц сети")}
                                        </Typography>
                                    </Col>
                                </Row>
                            ) : null}
                            {_.lte(price, 1100) ? null : (
                                <Row className="social-icons-row">
                                    <Col span={7}>
                                        {" "}
                                        <img
                                            src={yamap}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                        <img
                                            src={gis}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                        <img
                                            src={nav}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                        <img
                                            src={gmap}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                    </Col>
                                    <Col span={17}>
                                        {" "}
                                        <Typography as="div" className="social-icons-text">
                                            {t("Безлимит на Карты")}
                                        </Typography>
                                    </Col>
                                </Row>
                            )}
                            {_.lte(price, 1100) ? null : (
                                <Row className="social-icons-row">
                                    <Col span={7}>
                                        <img
                                            src={gmail}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                        <img
                                            src={mail}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                        <img
                                            src={ya}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                    </Col>
                                    <Col span={17}>
                                        <Typography as="div" className="social-icons-text">
                                            {t("Безлимит на Почту")}
                                        </Typography>
                                    </Col>
                                </Row>
                            )}
                            {_.lte(price, 1100) ? null : (
                                <Row className="social-icons-row">
                                    <Col span={7}>
                                        {" "}
                                        <img
                                            src={yt}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                        <img
                                            src={tt}
                                            width={14}
                                            alt="logo"
                                            className="social-icon"
                                        />
                                    </Col>
                                    <Col span={17}>
                                        {" "}
                                        <Typography as="div" className="social-icons-text">
                                            {t("Безлимит на Видео")}
                                        </Typography>
                                    </Col>
                                </Row>
                            )}

                            <Row className="social-icons-row">
                                <Col span={7}>
                                    <img src={bzv} width={16} alt="logo" className="social-icon " />
                                </Col>
                                <Col span={17}>
                                    {" "}
                                    <Typography as="div" className="social-icons-text">
                                        {t("Безлимит на Безлимит")}
                                    </Typography>
                                </Col>
                            </Row>

                            <Row className="social-icons-row">
                                <Col span={7}>
                                    {" "}
                                    <img src={bee} width={14} alt="logo" className="social-icon" />
                                </Col>
                                <Col span={17}>
                                    {" "}
                                    <Typography as="div" className="social-icons-text">
                                        {t("Безлимит на Билайн")}
                                    </Typography>
                                </Col>
                            </Row>
                        </>
                    )}
                </Space>
            </Col>
        </Row>
    );
}

interface IProps {
    price: number;
    group_name: string;
    sms: number;
    minutes: number;
    internet: number;
    id: number;
}
